import React, { useContext } from "react";
import { EligibilityContext } from "../../contexts/EligibilityContext";

const Role = () => {
  const context = useContext(EligibilityContext);

  const handleSubmit = (event) => {
    event.preventDefault();
    context.actions.setStep(2);
    context.actions.setModalOpen(true);
  };

  return (
    <form onSubmit={(event) => handleSubmit(event)} className="u-form">
      <div className="u-mb3">
        <label htmlFor="eligibilityRole">I am a...</label>
        <select
          name="role"
          id="eligibilityRole"
          onChange={(event) => context.actions.setRole(event.target.value)}
          value={context.state.role}
        >
          <option value="patient">Patient</option>
          <option value="provider">Provider</option>
          <option value="pharmacy">Pharmacy</option>
        </select>
      </div>

      <button className="btn" type="submit">
        Next
      </button>
    </form>
  );
};

export default Role;
